import React, { Component } from "react";

export default class Content extends Component {
  render() {
    return (
      <div className="m-2">
        <h2>
          <b>How to integrate TalentLMS with Zoom</b>
        </h2>
        <p>
          <a
            title="Link: https://zoom.us/"
            href="https://zoom.us/"
            target="_blank"
            rel="noopener"
          >
            {" "}
            Zoom.us
          </a>{" "}
          is a web conferencing service, providing cloud-based audio, video and
          screen-sharing solutions for Windows, iOS &amp; Android systems.
          TalentLMS lets you integrate your portal with Zoom to make the most of
          its advanced video conferencing capabilities.
        </p>
        <p>To do it, follow these steps:</p>
        <p>
          <strong>
            Step 1: Select a default videoconferencing platform (as
            Administrator)
          </strong>
        </p>
        <p>First, set Zoom.us as your preferred conference medium.</p>
        <p>
          Here's how:
          <br /> 1. Sign in to your TalentLMS account as{" "}
          <strong>Administrator </strong>and go to <strong>Home </strong>
          &gt; <strong>Account &amp; Settings</strong>.<br /> 2. In the{" "}
          <strong>Conferences </strong>section, use the{" "}
          <strong>Type (1) </strong>drop-down list to choose{" "}
          <strong>Zoom.us (2)</strong>.
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360040424594/Zoom.png"
            alt="Zoom.png"
          />
        </p>
        <p>
          After selecting Zoom.us from the dropdown, you will see an option for
          <strong> Maximum capacity (3)</strong>. Here you can set a limit for
          the number of users permitted to join the webinar. If left as 0, the
          default capacity of Zoom.us will be applied (100).
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360040280854/zoomCapacity.png"
            alt="zoomCapacity.png"
          />
        </p>
        <p>
          <strong>
            Step 2: Connect your Zoom account to TalentLMS (as Instructor)
          </strong>
        </p>
        <p>
          Instructors responsible for creating live training events must connect
          their Zoom account to TalentLMS.
        </p>
        <p>
          Here's how:
          <br /> <br /> 1. Sign in to zoom.us and select{" "}
          <strong>Advanced &gt; App Marketplace </strong>from the left-side
          menu, or go directly to <strong>marketplace.zoom.us </strong>and sign
          in with your Zoom credentials.
        </p>
        <p>
          2. Select <strong>Build App</strong> from the{" "}
          <strong>Develop (1)</strong> dropdown on top of the page.
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012571519/zoom_mrkt1.png"
            alt="zoom_mrkt1.png"
          />
        </p>
        <p>
          <span>
            3. Select <strong>oAuth </strong>as your app type, give your
            <strong> app a name (2),</strong> and select{" "}
            <strong>
              User-managed app (3).
              <br />
            </strong>
            4. Turn off the{" "}
            <strong>
              Would you like to publish this app on Zoom App Marketplace? (4)
            </strong>{" "}
            option. Then click <strong>Create(5).</strong>
          </span>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012579320/zoom__8_.png"
            alt="zoom__8_.png"
          />
        </p>
        <p>
          5. You will be redirected to the App Credentials tab of your Zoom app.
        </p>
        <p>
          <span>Here you can find the </span>
          <strong>Client ID (6)</strong>
          <span> and </span>
          <strong>Client Secret (7)</strong>
          <span> which you are going to need later in the process.</span>
        </p>
        <p>
          <span>Fill in the </span>
          <strong>Redirect URL for OAuth (8)</strong>
          <span> field setting its value to </span>
          <em>
            <span>https://mydomain.talentlms.com/conference/zoomauth</span>
          </em>
          <span> (if you use a mapped domain – let's say </span>
          <em>
            <span>mydomain.com</span>
          </em>
          <span> – set the value to the equivalent, like </span>
          <em>
            <span>https://mydomain.com/conference/zoomauth</span>
          </em>
          <span>).</span>
        </p>
        <p>
          <span>In the </span>
          <strong>Whitelist URL (9)</strong>
          <span>
            {" "}
            field, type in your domain's URL (https://mydomain.talentlms.com/ or
            https://mydomain.com/ if you use a mapped domain).
          </span>
        </p>
        <p>
          <span>Then click </span>
          <strong>Continue (10)</strong>
          <span>.</span>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012579380/zoom__2_.png"
            alt="zoom__2_.png"
          />
        </p>
        <p>
          6. You now have reached the Information page of your app. Fill in the
          required info and click <strong>Continue (11)</strong>.
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012572019/zoom__3_.png"
            alt="zoom__3_.png"
          />
        </p>
        <p>
          <span>7. You are now in the </span>
          <strong>Feature </strong>
          <span>tab of your app, click Continue again.</span>
        </p>
        <p>
          <span>8. In the </span>
          <strong>Scopes (12) </strong>
          <span>tab</span> <span>click the </span>
          <strong>Add Scopes (13)</strong>
          <span> button. </span>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012572079/zoom__4_.png"
            alt="zoom__4_.png"
          />
        </p>
        <p>
          <span>Click</span>
          <strong> Meeting (14)</strong>
          <span> on the left, and select the </span>
          <strong>View and manage your meetings (15)</strong>
          <span> option. Click </span>
          <strong>Done (16)</strong>
          <span>, then click </span>
          <strong>Continue </strong>to <strong>Install your app.</strong>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012579620/zoom__5_.png"
            alt="zoom__5_.png"
          />
        </p>
        <p>
          <span>
            9. Sign in to your TalentLMS portal and switch to the Instructor
            role. From the right-hand panel, go to Conferences. Click the
            drop-down option and select{" "}
          </span>
          <strong>Connect with Zoom.us (17)</strong>
          <span>.</span>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012579680/zoom__6_.png"
            alt="zoom__6_.png"
          />
        </p>
        <p>
          <span>10. On the dialog box that pops up, type the </span>
          <strong>Client ID</strong>
          <span> and </span>
          <strong>Client Secret (18)</strong>
          <span> in the respective fields, and click </span>
          <strong>Connect (19)</strong>
          <span>. </span>
        </p>
        <p>
          <img
            src="https://help.talentlms.com/hc/article_attachments/360012572139/zoom__7_.png"
            alt="zoom__7_.png"
          />
        </p>
        <p>
          You will be now redirected to Zoom. You will need to login to your
          account to complete the connection and associate your TalentLMS
          account with your Zoom account. If you were already logged in to your
          Zoom account you will skip this step.
        </p>
      </div>
    );
  }
}
